import numeral from "numeral";
import { FaImage, FaFile } from "react-icons/fa";
import { RiFileExcel2Fill } from "react-icons/ri";
import { FaFilePdf } from "react-icons/fa6";
import { RiFileWord2Fill } from "react-icons/ri";
import axios from "axios";
import URL from "src/URL";
import dayjs from "dayjs";

export const getStatusBgColor = (status) => {
  if (status === "Awaiting Approval" || status === "In Progress") {
    return "blue-500";
  } else if (status === "Approved") {
    return "lime-500";
  } else if (status === "Completed") {
    return "green-500";
  } else if (status === "Draft") {
    return "yellow-500";
  } else if (status === "Canceled") {
    return "red-500";
  } else {
    return "gray-500";
  }
};
export const handleDeleteItem = (items, setItems, id) => {
  const newItems = items.filter((item) => item.id !== id);
  setItems(newItems);
};

// Function to get appropriate color based on status
export const getStatusColor = (status) => {
  switch (status) {
    case 1: // Draft
      return "bg-yellow-500 text-white"; // Gray
    case 2: // Awaiting Approval
      return "bg-blue-500 text-white"; // Yellow
    case 3: // Approved
      return "bg-lime-500 text-white"; // Green
    case 4: // Completed
      return "bg-blue-500 text-white"; // Blue
    case 5: // Canceled
      return "bg-red-500 text-white"; // Red
    default:
      return "bg-gray-400 text-black"; // Default gray
  }
};

export const getStatusTextColors = (status) => {
  switch (status) {
    case 1: // Draft
      return "bg-yellow-500 text-white"; // Gray
    case 2: // Awaiting Approval
      return "bg-green-500 text-white"; // Yellow
    case 3: // Approved
      return "bg-red-500 text-white"; // Green
    case 4: // Completed
      return "bg-blue-500 text-white"; // Blue
    case 5: // Canceled
      return "bg-red-500 text-white"; // Red
    default:
      return "bg-gray-400 text-black"; // Default gray
  }
};

// Function to get appropriate color based on status
export const getStatusTextColor = (status) => {
  switch (status) {
    case 1: // Draft
      return "text-yellow-500"; // Gray
    case 2: // Awaiting Approval
      return "text-blue-500"; // Yellow
    case 3: // Approved
      return "text-lime-500"; // Green
    case 4: // Completed
      return "text-green-500"; // Blue
    case 5: // Canceled
      return "text-red-500"; // Red
    default:
      return "text-gray-400"; // Default gray
  }
};

// Function to get appropriate color based on status
export const getStatusText = (status) => {
  switch (status) {
    case 1: // Draft
      return "Draft"; // Gray
    case 2: // Awaiting Approval
      return "Awaiting Approval"; // Yellow
    case 3: // Approved
      return "Approved"; // Green
    case 4: // Completed
      return "Completed"; // Blue
    case 5: // Canceled
      return "Canceled"; // Red
    default:
      return "text-gray-400"; // Default gray
  }
};

export const getStatusTextForm = (status) => {
  switch (status) {
    case 1: // Draft
      return "Pending"; // Gray
    case 2: // Awaiting Approval
      return "Approved"; // Yellow
    case 3: // Approved
      return "Rejected"; // Green
    case 4: // Completed
      return "Completed"; // Blue
    default:
      return "text-gray-400"; // Default gray
  }
};

// Function to get appropriate color based on status
export const riskStatusBgColor = (status) => {
  switch (status) {
    case "Possible":
      return "rounded py-1.5 px-2 text-white bg-orange-500";
    case "Likely":
      return "rounded py-1.5 px-2 text-white bg-red-600";
    case "Unlikely":
      return "rounded py-1.5 px-2 text-white bg-yellow-400";
    case "Rare":
      return "rounded py-1.5 px-2 text-white bg-lime-500";
    case "Almost Certain":
      return "rounded py-1.5 px-2 text-white bg-red-600";
    default:
      return "rounded py-1.5 px-2 text-white bg-blue-400";
  }
};

// Function to get appropriate color based on status
export const preImpactBgColor = (status) => {
  switch (status) {
    case "Moderate":
      return "rounded py-1.5 px-2 text-white bg-orange-500";
    case "Major":
      return "rounded py-1.5 px-2 text-white bg-red-600";
    case "Insignificant":
      return "rounded py-1.5 px-2 text-white bg-lime-500";
    case "Minor":
      return "rounded py-1.5 px-2 text-white bg-yellow-400";
    case "Extreme/ Severe":
      return "rounded py-1.5 px-2 text-white bg-red-600";
    default:
      return "rounded py-1.5 px-2 text-white bg-blue-400";
  }
};

// Function to get appropriate color based on status
export const preRatingBm = (status) => {
  switch (status) {
    case "Significant":
      return "rounded py-1.5 px-2 text-white bg-orange-500";
    case "High":
      return "rounded py-1.5 px-2 text-white bg-red-600";
    case "Moderate":
      return "rounded py-1.5 px-2 text-white bg-yellow-400";
    case "Low":
      return "rounded py-1.5 px-2 text-white bg-lime-500";
    default:
      return "rounded py-1.5 px-2 text-white bg-blue-400";
  }
};

// Function to get appropriate color based on status
export const postLikeliHoodBgColor = (status) => {
  switch (status) {
    case "Possible":
      return "rounded py-1.5 px-2 text-white bg-orange-500";
    case "Likely":
      return "rounded py-1.5 px-2 text-white bg-red-600";
    case "Unlikely":
      return "rounded py-1.5 px-2 text-white bg-yellow-400";
    case "Rare":
      return "rounded py-1.5 px-2 text-white bg-lime-500";
    case "Almost Certain":
      return "rounded py-1.5 px-2 text-white bg-red-600";
    default:
      return "rounded py-1.5 px-2 text-white bg-blue-400";
  }
};

// Function to get appropriate color based on status
export const postImpactBgColor = (status) => {
  switch (status) {
    case "Moderate":
      return "rounded py-1.5 px-2 text-white bg-orange-500";
    case "Major":
      return "rounded py-1.5 px-2 text-white bg-red-600";
    case "Insignificant":
      return "rounded py-1.5 px-2 text-white bg-lime-500";
    case "Minor":
      return "rounded py-1.5 px-2 text-white bg-yellow-400";
    case "Extreme/ Severe":
      return "rounded py-1.5 px-2 text-white bg-red-600";
    default:
      return "rounded py-1.5 px-2 text-white bg-blue-400";
  }
};

// Function to get appropriate color based on status
export const postResidualRisk = (status) => {
  switch (status) {
    case "Significant":
      return "rounded py-1.5 px-2 text-white bg-orange-500";
    case "High":
      return "rounded py-1.5 px-2 text-white bg-red-600";
    case "Moderate":
      return "rounded py-1.5 px-2 text-white bg-yellow-400";
    case "Low":
      return "rounded py-1.5 px-2 text-white bg-lime-500";
    default:
      return "rounded py-1.5 px-2 text-white bg-blue-400";
  }
};

// Reusable toast configuration
export const toastConfig = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

export function fData(number) {
  return numeral(number).format("0.0 b");
}

export const getFileIcon = (filename) => {
  const ext = filename?.split(".").pop().toLowerCase();
  switch (ext) {
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
      return <FaImage className="text-blue-500" size="22px" />;
    case "xlsx":
    case "xls":
      return <RiFileExcel2Fill className="text-green-600" size="22px" />;
    case "doc":
    case "docx":
      return <RiFileWord2Fill className="text-[#2b579a]" size="22px" />;
    case "pdf":
      return <FaFilePdf className="text-red-500" size="22px" />;
    default:
      return <FaFile className="text-blue-500" size="22px" />;
  }
};

export const fetchCountries = async () => {
  try {
    const filterParams = new URLSearchParams({
      access: "limited",
    }).toString();
    const response = await axios.get(
      `${URL}api/v1/store/countries?${filterParams}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching countries", error);
    throw error;
  }
};

export const fetchRegions = async (countryId) => {
  try {
    const params = {
      country_id: countryId,
      access: "limited",
    };

    const filterParams = new URLSearchParams(params).toString();
    const response = await axios.get(
      `${URL}api/v1/store/regions?${filterParams}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching regions", error);
    throw error;
  }
};

export const getFormattedDate = (date) => {
  const day = dayjs(date).date();
  const monthYear = dayjs(date).format("MMM YYYY");

  // Add ordinal suffix to the day
  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return `${day}th`; // handles 11th, 12th, 13th
    switch (day % 10) {
      case 1:
        return `${day}st`;
      case 2:
        return `${day}nd`;
      case 3:
        return `${day}rd`;
      default:
        return `${day}th`;
    }
  };

  return `${getOrdinalSuffix(day)} ${monthYear}`;
};

export const isButtonDisabled = (item) => {
  if (!item || !item.scoring) return true; // Disable the button if item or scoring is not defined
  return (
    item.scoring.proposal_information?.assessment_submitted === false ||
    item.scoring.engagement_plan?.engagement_plan_submitted === false ||
    item.scoring.gantt_chart?.gantt_chart_submitted === false ||
    item.scoring.stage_gates?.stage_gates?.submitted === false ||
    item.scoring.meal_plan?.meal_plan_submitted === false ||
    item.scoring.resources?.resources_submitted === false ||
    item.scoring.budget_plan?.budget_plan_submitted === false
  );
};

export function months() {
  return new Array(12).fill(0);
}

export const successStyles = {
  duration: 3000,
  style: {
    background: "#16a34a",
    color: "white",
  },
  theme: {
    primary: "#16a34a",
    secondary: "white",
  },
  iconTheme: {
    primary: "white",
    secondary: "#16a34a",
  },
};

export const errorStyles = {
  duration: 3000,
  style: {
    background: "#dc2626",
    color: "white",
  },
  theme: {
    primary: "#dc2626",
    secondary: "white",
  },
  iconTheme: {
    primary: "white",
    secondary: "#dc2626",
  },
};

export const Section = ({
  index,
  title,
  subtitle,
  children,
  className = "",
}) => (
  <div
    className={`bg-white border border-slate-200 rounded-2xl shadow-[0_1px_2px_rgba(15,23,42,0.04)] ${className}`}
  >
    <div className="flex items-start gap-3 px-6 pt-5 pb-4 border-b border-slate-100 bg-slate-50">
      {index && (
        <span className="text-[12px] font-medium text-slate-900 tabular-nums tracking-wide bg-slate-200 px-2 py-1 rounded">
          {index}
        </span>
      )}
      <div>
        <h4 className="text-[13px] font-semibold text-slate-900 tracking-tight">
          {title}
        </h4>
        {subtitle && (
          <p className="text-xs text-slate-400 mt-0.5">{subtitle}</p>
        )}
      </div>
    </div>
    <div className="flex flex-col gap-5 px-6 py-5">{children}</div>
  </div>
);

export const Row = ({ children }) => (
  <div className="flex flex-col sm:flex-row gap-5 [&>*]:flex-1">{children}</div>
);

export const money = (value) =>
  (value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
